import { render, staticRenderFns } from "./compensationRule.vue?vue&type=template&id=4a77939d&scoped=true&"
import script from "./compensationRule.vue?vue&type=script&lang=js&"
export * from "./compensationRule.vue?vue&type=script&lang=js&"
import style0 from "./compensationRule.vue?vue&type=style&index=0&id=4a77939d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77939d",
  null
  
)

export default component.exports